import { Nilable } from "@shared/utils";

export interface IClienteDTO {
    id: number;
    name: string;
    password?: Nilable<string>;
    email: string;
    logo: Nilable<string>;
    fullname?: Nilable<string>;
    name_subscription?: Nilable<string>;
    created_at?: Nilable<string>;
    last_activity?: Nilable<string>;
}

export class ClienteDTO {
    public id = 0;
    public nombre = "";
    public password = "";
    public email = "";
    public logo: Nilable<string> = null;
    public nombreCompleto: Nilable<string>;
    public subscriptionNombre: Nilable<string> = null;
    public creadoEl: Nilable<Date> = null;
    public ultimaActividad: Nilable<Date> = null;

    constructor(json: Nilable<Partial<IClienteDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IClienteDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.password != null) {
            this.password = json.password;
        }
        if (json.email != null) {
            this.email = json.email;
        }
        if (json.logo != null) {
            this.logo = json.logo;
        }
        if (json.fullname != null) {
            this.nombreCompleto = json.fullname;
        }
        if (json.name_subscription != null) {
            this.subscriptionNombre = json.name_subscription;
        }
        if (json.created_at != null) {
            this.creadoEl = new Date(json.created_at);
        }
        if (json.last_activity != null) {
            this.ultimaActividad = new Date(json.last_activity);
        }
    }

    public toJSON(): IClienteDTO {
        const cliente: IClienteDTO = {
            id: this.id,
            name: this.nombre,
            email: this.email,
            logo: this.logo,
            fullname: this.nombreCompleto ?? "",
            name_subscription: this.subscriptionNombre ?? null,
            created_at: this.creadoEl?.toJSON(),
            last_activity: this.ultimaActividad?.toJSON()
        };
        if (this.password !== "") {
            cliente.password = this.password;
        }
        return cliente;
    }
}
